import axios from "axios";
import liff from "@line/liff";
import rs_line from "@/config/rs_line";
import { useAppStore } from "@/stores/app";
import { getCurrentEnv, SUPPORT_ENV } from "@/utils/util";

let config: any  = 'dev';
const env: any = getCurrentEnv();

if (env === SUPPORT_ENV.prod) {
  config = rs_line.prod;
} else if (env === SUPPORT_ENV.qa) {
  config = rs_line.qa;
} else {
  config = rs_line.dev;
}

export default class Authentication {
  get openID(): string {
    const openID = localStorage.getItem("openID") || "";
    return openID;
  }

  public async authorize(email: string, password: string) {
    if (this.openID) {
      const response = await axios({
        baseURL: config.base_url,
        url: `/login`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: { email, password, openID: this.openID },
      });

      const authData = response.data as LoginSuccess;
      this.setAuthentication(authData);
      return authData;
    } else return;
  }

  public async lambdaAuthorize(
    accessToken: string,
    idTokenClaims: string,
    type: string
  ): Promise<LoginSuccess> {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      "x-id-token": idTokenClaims,
    };
    const response = await axios({
      url: `${config.base_url}/login`,
      method: "POST",
      headers,
      data: {
        openID: this.openID,
        type,
      },
    });

    const authData = response.data as LoginSuccess;
    this.setAuthentication(authData);
    return authData;
  }

  public async initLiff() {
    const app = useAppStore();
    try {
      app.setIsloading(true);
      await liff.init({ liffId: config.liff_id });
      if (liff.isInClient()) {
        const context = liff.getContext();
        if (context && context.userId) this.setOpenID(context.userId);
        else throw new Error();
      } else throw new Error();
    } catch (error) {
      window.alert("Error! Please open this in LINE app. \nLiff ID app:" + config.liff_id + " vs " + liff.id+"\nError: "+error);
    } finally {
      app.setIsloading(false);
    }
  }

  public setOpenID(userId: string) {
    localStorage.setItem("openID", userId);
  }

  private setAuthentication(data: LoginSuccess) {
    localStorage.setItem("authentication", JSON.stringify(data));
  }

  public async logout() {
    const data = { type: "logout", openID: this.openID };
    await axios({
      url: `${config.base_url}/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data,
    });

    localStorage.removeItem("authentication");
  }

  public async checkLoggedIn(
    openID: string,
    accessToken: string
  ): Promise<boolean | void> {
    const app = useAppStore();
    try {
      app.setIsloading(true);
      const checkAuthResponse = await axios({
        url: `${config.base_url}/login`,
        method: "POST",
        data: {
          openID,
          type: "check-login",
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const { isLoggedIn } = checkAuthResponse.data as CheckAuthResponse;
      app.setIsloading(false);
      return isLoggedIn;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
